.item {
  padding: var(--sp-5);
  border-left: 3px solid var(--accent);
  background: var(--surface-raised);
  border-radius: 0 var(--radius) var(--radius) 0;
}
.title {
  font-size: var(--fs-lg);
  margin-bottom: var(--sp-2);
}
.text {
  margin: 0;
}
